import axios from "../utils/axios";

// ==========================================
// Roles
// ==========================================

export const getRoles = async (params) => {
    const response = await axios.get("/roles", { params });
    return response.data;
};

export const getRoleById = async (id) => {
    const response = await axios.get(`/roles/${id}`);
    return response.data;
};

export const createRole = async (data) => {
    const response = await axios.post("/roles", data);
    return response.data;
};

export const updateRole = async (id, data) => {
    const response = await axios.put(`/roles/${id}`, data);
    return response.data;
};

export const deleteRole = async (id) => {
    const response = await axios.delete(`/roles/${id}`);
    return response.data;
};

export const massDestroyRoles = async (data) => {
    const response = await axios.delete("/roles/mass-destroy", { data });
    return response.data;
};

export const massRestoreRoles = async (data) => {
    const response = await axios.post("/roles/mass-restore", data);
    return response.data;
};

export const massForceDeleteRoles = async (data) => {
    const response = await axios.delete("/roles/mass-force-delete", { data });
    return response.data;
};

// ==========================================
// Permissions
// ==========================================

export const getPermissions = async () => {
    const response = await axios.get("/permissions");
    return response.data;
};

// ==========================================
// User Roles
// ==========================================

export const getUserRoles = async (userId) => {
    const response = await axios.get(`/users/${userId}/roles`);
    return response.data;
};

export const syncUserRoles = async (userId, data) => {
    const response = await axios.post(`/users/${userId}/roles`, data);
    return response.data;
};
